const qk = {
  list: (appId?: string) => ["apps", appId, "segments"] as const,

  metadata: (appId?: string) =>
    ["apps", appId, "segments", "metadata"] as const,

  counts: (appId?: string, envId?: string) =>
    ["apps", appId, "environments", envId, "segments", "counts"] as const,
};

export { qk as segmentQueryKeys };
